// src/app-config/appConfigApi.ts
import { apiClient } from "@maat/api-base";
var appConfigApi = {
  getFeatures: async () => {
    return apiClient.get("/main/api/app-config/features");
  }
};

export {
  appConfigApi
};
